import { Link } from "react-router-dom";
import { Icon } from "@/components/Icon";

/**
 * ArticleBottomNav — два пілли внизу статті (юзер 2026-06-25):
 *   • «Назад» → до списку статей (база знань / вибір іншої статті)
 *   • «Меню»  → на головну
 */
export function ArticleBottomNav({
  backTo = "/knowledge-base",
  backLabel = "Назад",
}: {
  backTo?: string;
  backLabel?: string;
}) {
  const pill =
    "flex h-11 flex-1 items-center justify-center gap-1.5 rounded-full bg-surface-soft font-display text-[0.8125rem] font-semibold text-ink shadow-card-soft active:scale-[0.97] transition";
  return (
    <div className="mt-8 mb-4 flex items-center gap-2">
      <Link to={backTo} className={pill}>
        <Icon
          name="arrow-right"
          size={14}
          className="rotate-180"
          color="#FE6B04"
        />
        {backLabel}
      </Link>
      <Link to="/" className={pill}>
        Меню
        <Icon name="home" size={14} color="#FE6B04" />
      </Link>
    </div>
  );
}
